import React, { useState } from 'react'
import { GoTriangleDown, GoTriangleRight } from 'react-icons/go'
import { IconContext } from 'react-icons'
import {
  FaCloudSunRain,
  FaConciergeBell,
  FaDoorOpen,
  FaHiking,
  FaMap,
  FaMoneyBillWave,
  FaWheelchair,
} from 'react-icons/fa'
import PropTypes from 'prop-types'
import styles from './infoSection.module.css'

export const getFontAwesomeComponent = icon => {
  let fa
  switch (icon) {
    case 'accessible':
      fa = <FaWheelchair />
      break
    case 'map':
      fa = <FaMap />
      break
    case 'bell':
      fa = <FaConciergeBell />
      break
    case 'weather':
      fa = <FaCloudSunRain />
      break
    case 'open':
      fa = <FaDoorOpen />
      break
    case 'money':
      fa = <FaMoneyBillWave />
      break
    case 'hike':
      fa = <FaHiking />
      break
    default:
      fa = null
  }
  return fa
}

const InfoSection = ({ children, icon, title }) => {
  const [isSectionOpen, setSectionOpen] = useState(true)
  return (
    <div className={styles.infoSection}>
      <div
        className={styles.sectionHeader}
        onClick={() => setSectionOpen(!isSectionOpen)}
      >
        <div className={styles.iconAndTitle}>
          <div>
            <IconContext.Provider value={{ color: '#636363', size: '35' }}>
              {getFontAwesomeComponent(icon)}
            </IconContext.Provider>
          </div>
          <h3 className={styles.sectionTitle}>{title}</h3>
        </div>
        <div className={styles.openIndicator}>
          <IconContext.Provider value={{ color: '#636363', size: '30' }}>
            {isSectionOpen ? <GoTriangleDown /> : <GoTriangleRight />}
          </IconContext.Provider>
        </div>
      </div>
      {isSectionOpen ? children : null}
    </div>
  )
}

InfoSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  icon: PropTypes.string,
  title: PropTypes.string,
}

export default InfoSection
